var script = function() {
  this.video;
  this.recorder;
  this.startBtn;
  this.stopBtn;
  this.callback = function() {};

  this.checkBrowser = function() {
    if (!navigator.getDisplayMedia && !navigator.mediaDevices.getDisplayMedia) {
      var error = "Your browser does NOT support the getDisplayMedia API.";
      document.querySelector("h1").innerHTML = error;

      this.video.style.display = "none";
      this.startBtn.style.display = "none";
      this.stopBtn.style.display = "none";
      throw new Error(error);
    }
  };

  this.invokeGetDisplayMedia = function(success, error) {
    var displaymediastreamconstraints = {
      video: {
        displaySurface: "monitor", // monitor, window, application, browser
        logicalSurface: true,
        cursor: "always" // never, always, motion
      }
    };

    // above constraints are NOT supported YET
    // that's why overridnig them
    displaymediastreamconstraints = {
      video: true
    };

    if (navigator.mediaDevices.getDisplayMedia) {
      navigator.mediaDevices
        .getDisplayMedia(displaymediastreamconstraints)
        .then(success)
        .catch(error);
    } else {
      navigator
        .getDisplayMedia(displaymediastreamconstraints)
        .then(success)
        .catch(error);
    }
  };

  this.captureScreen = function(callback) {
    this.invokeGetDisplayMedia(
      function(screen) {
        this.addStreamStopListener(
          screen,
          function() {
            this.stopBtn.click();
          }.bind(this)
        );
        callback(screen);
      }.bind(this),
      function(error) {
        console.error(error);
        alert(
          "Unable to capture your screen. Please check console logs.\n" + error
        );
      }
    );
  };

  this.stopRecordingCallback = function() {
    this.video.src = this.video.srcObject = null;
    this.video.src = URL.createObjectURL(this.recorder.getBlob());
    this.recorder.screen.stop();
    this.callback(this.recorder.getBlob());
    this.recorder.destroy();
    this.recorder = null;
    this.startBtn.disabled = false;
  };

  this.listener = function() {
    this.checkBrowser();

    this.startBtn.onclick = function() {
      this.startBtn.disabled = true;
      this.video.classList.remove("hidden");

      this.captureScreen(
        function(screen) {
          this.video.srcObject = screen;

          this.recorder = this.RecordRTC(screen, {
            type: "video",
            frameRate: 20,
            bitrate: 128000,
            elementClass: "multi-streams-mixer",
            canvas: {
              width: 640,
              height: 480
            }
          });

          this.recorder.startRecording({
            enableScreen: true,
            enableMicrophone: true,
            enableSpeakers: true
          });

          // release screen on stopRecording
          this.recorder.screen = screen;

          this.stopBtn.disabled = false;
        }.bind(this)
      );
    }.bind(this);

    this.stopBtn.onclick = function() {
      this.stopBtn.disabled = true;
      this.recorder.stopRecording(this.stopRecordingCallback);
    }.bind(this);
  };

  this.addStreamStopListener = function(stream, callback) {
    stream.addEventListener(
      "ended",
      function() {
        callback();
        callback = function() {};
      },
      false
    );
    stream.addEventListener(
      "inactive",
      function() {
        callback();
        callback = function() {};
      },
      false
    );
    stream.getTracks().forEach(function(track) {
      track.addEventListener(
        "ended",
        function() {
          callback();
          callback = function() {};
        },
        false
      );
      track.addEventListener(
        "inactive",
        function() {
          callback();
          callback = function() {};
        },
        false
      );
    });
  };
};

export { script };
